import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://naturfag-klar.impultienda.ar/checkout';
const TRACKING_KEY = 'nk_tracking_qs';
const TRACKING_PARAMS = /^(utm_|fbclid$|gclid$|ttclid$|src$|sck$|xcod$)/;

/** Keeps utm_*, fbclid etc. from the landing URL (also across in-page navigation). */
function getTrackingQuery(): string {
  if (typeof window === 'undefined') return '';
  const current = new URLSearchParams(window.location.search);
  const kept = new URLSearchParams();
  current.forEach((value, key) => {
    if (TRACKING_PARAMS.test(key)) kept.set(key, value);
  });
  let qs = kept.toString();
  try {
    if (qs) {
      window.sessionStorage.setItem(TRACKING_KEY, qs);
    } else {
      qs = window.sessionStorage.getItem(TRACKING_KEY) || '';
    }
  } catch {
    // sessionStorage unavailable: fall back to the current URL only
  }
  return qs;
}
export function withTracking(href: string): string {
  if (href.startsWith('#')) return href;
  const qs = getTrackingQuery();
  if (!qs) return href;
  try {
    const url = new URL(href);
    new URLSearchParams(qs).forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });
    return url.toString();
  } catch {
    return href + (href.includes('?') ? '&' : '?') + qs;
  }
}
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Skaff NATURFAG KLAR™ nå',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const [finalHref, setFinalHref] = useState<string>(href);
  useEffect(() => {
    setFinalHref(withTracking(href));
  }, [href]);
  return <a href={finalHref} onClick={() => {
    if (!isInternal) setFinalHref(withTracking(href));
  }} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-full bg-red-700 px-5 py-4 text-center text-sm font-semibold text-white shadow-lg shadow-red-700/30 transition-[transform,background-color] duration-150 ease-out hover:bg-red-800 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/30 sm:px-9 sm:py-5 sm:text-base ${className}`} data-id="element-66" data-mp="6h98bbmx0vl8">
      <span data-id="element-67" data-mp="3rv8xi1rm9tvb">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-68" data-mp="9ikiv54xck0i" />
    </a>;
}